import React from 'react';
// react plugin for creating charts
import ChartistGraph from 'react-chartist';
// @material-ui/core
import withStyles from '@material-ui/core/styles/withStyles';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Store from '@material-ui/icons/Store';
import Warning from '@material-ui/icons/Warning';
import DateRange from '@material-ui/icons/DateRange';
import LocalOffer from '@material-ui/icons/LocalOffer';
import Update from '@material-ui/icons/Update';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import AccessTime from '@material-ui/icons/AccessTime';
import Accessibility from '@material-ui/icons/Accessibility';

// core components
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import Danger from '../../../components/Typography/Danger';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardIcon from '../../../components/Card/CardIcon';
import CardBody from '../../../components/Card/CardBody';
import CardFooter from '../../../components/Card/CardFooter';
import AssetTableList from '../../Asset/TableList'

import {
  assetsPieChart,
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from '../../../variables/charts';

import dashboardStyle from '../../../assets/jss/material-dashboard-react/views/dashboardStyle';

interface Props {
  classes: any;
}

interface State {
  value: number;
}

class Dashboard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: 0
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
  }
  handleChange = (event: any, value: number) => {
    this.setState({ value });
  }

  handleChangeIndex = (index: number) => {
    this.setState({ value: index });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="warning" stats={true} icon={true}>
                <CardIcon color="warning">
                  <Icon>content_copy</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Total Assets</p>
                <h3 className={classes.cardTitle}>
                  600
                </h3>
              </CardHeader>
              <CardBody>
                <ChartistGraph
                  className="ct-chart"
                  data={assetsPieChart.data1}
                  type="Pie"
                  options={assetsPieChart.options}
                  //listener={dailySalesChart.animation}
                />
              </CardBody>
              <CardFooter stats={true}>
                <div className={classes.stats}>
                  <Danger>
                    <Warning />
                  </Danger>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    status: partial failure
                  </a>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="success" stats={true} icon={true}>
                <CardIcon color="success">
                  <Store />
                </CardIcon>
                <p className={classes.cardCategory}>Assets Ok</p>
                <h3 className={classes.cardTitle}>542</h3>
              </CardHeader>
              <CardBody>
                <ChartistGraph
                  className="ct-chart"
                  data={assetsPieChart.data2}
                  type="Pie"
                  options={assetsPieChart.options}
                  //listener={dailySalesChart.animation}
                />
              </CardBody>
              <CardFooter stats={true}>
                <div className={classes.stats}>
                  <DateRange />
                  Last 24 Hours
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="info" stats={true} icon={true}>
                <CardIcon color="info">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>At Risk</p>
                <h3 className={classes.cardTitle}>43</h3>
              </CardHeader>
              <CardBody>
                <ChartistGraph
                  className="ct-chart"
                  data={assetsPieChart.data3}
                  type="Pie"
                  options={assetsPieChart.options}
                  //listener={dailySalesChart.animation}
                />
              </CardBody>
              <CardFooter stats={true}>
                <div className={classes.stats}>
                  <LocalOffer />
                  Predictive Tracking
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="danger" stats={true} icon={true}>
                <CardIcon color="danger">
                  <Accessibility />
                </CardIcon>
                <p className={classes.cardCategory}>Asset Failure</p>
                <h3 className={classes.cardTitle}>15</h3>
              </CardHeader>
              <CardBody>
                <ChartistGraph
                  className="ct-chart"
                  data={assetsPieChart.data4}
                  type="Pie"
                  options={assetsPieChart.options}
                  //listener={dailySalesChart.animation}
                />
              </CardBody>
              <CardFooter stats={true}>
                <div className={classes.stats}>
                  <Update />
                  Just Updated
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Card chart={true}>
              <CardHeader color="success">
                <ChartistGraph
                  className="ct-chart"
                  data={dailySalesChart.data}
                  type="Line"
                  options={dailySalesChart.options}
                  listener={dailySalesChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Overall Equipment Effiencies</h4>
                <p className={classes.cardCategory}>
                  <span className={classes.dangerText}>
                    <ArrowDownward className={classes.upArrowCardCategory} /> 72.5%
                  </span>{' '}
                  Lower OEE recorded
                </p>
              </CardBody>
              <CardFooter chart={true}>
                <div className={classes.stats}>
                  <AccessTime /> updated 4 minutes ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card chart={true}>
              <CardHeader color="warning">
                <ChartistGraph
                  className="ct-chart"
                  data={emailsSubscriptionChart.data}
                  type="Bar"
                  options={emailsSubscriptionChart.options}
                  // responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  // listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Availability</h4>
                <p className={classes.cardCategory}>
                <span className={classes.dangerText}>
                    <ArrowDownward className={classes.upArrowCardCategory} /> 85%
                  </span>{' '}
                  Lower Availability
                </p>
              </CardBody>
              <CardFooter chart={true}>
                <div className={classes.stats}>
                  <AccessTime /> updated 4mins ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card chart={true}>
              <CardHeader color="danger">
                <ChartistGraph
                  className="ct-chart"
                  data={completedTasksChart.data}
                  type="Line"
                  options={completedTasksChart.options}
                  listener={completedTasksChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Performance</h4>
                <p className={classes.cardCategory}>
                <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} /> 90%
                  </span>{' '}
                  Improved rate of Performance
                </p>
              </CardBody>
              <CardFooter chart={true}>
                <div className={classes.stats}>
                  <AccessTime /> updated 4min ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
           <AssetTableList />
          </GridItem>

        </GridContainer>
      </div>
    );
  }
}

// Dashboard.propTypes = {
//   classes: PropTypes.object.isRequired
// };

export default withStyles(dashboardStyle)(Dashboard);
